"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlockInteractionManager = void 0;
var _BlockState = require("./BlockState");
var _variables = require("@blockwell/variables");
class BlockInteractionManager extends _BlockState.ManagerWithState {
  constructor(state) {
    super(state);
    state.type.setInteractions(state.spec.act, state.registry.variableTypes);
  }
  interact(interaction) {
    this.registry.interact(interaction);
  }
  updateInteractions(update) {
    var _this$registry;
    let i = 0;
    for (let it of update) {
      const old = this.spec.act[i];
      const ref = this.type.interactions[i];
      if (old) {
        old.type = it.type;
        old.actions = it.actions;
        if (ref) {
          ref.updateAllParameters(old);
        }
      } else {
        this.spec.act.push({
          type: it.type,
          param: it.param,
          actions: it.actions
        });
        let spec = this.spec.act[i];
        let ref = new _variables.VariableReference(this.registry.variableTypes.get("interaction"), spec, true);
        this.type.interactions.push(ref);
        this.type.blockVariables.push({
          ref
        });
        if (this.context) {
          this.context.addVariable(this.key, null, ref, `owner=${this.key}; block=${this.type.type}; var=${ref.variableType}; index=${ref.index}`);
          this.block.variableAdded({
            ref
          });
        }
      }
      ++i;
    }
    while (i < this.spec.act.length) {
      let popped = this.spec.act.pop();
      let index = this.spec.act.length;
      let ref = this.type.interactions[index];
      if (ref) {
        this.type.interactions.splice(index, 1);
        if (this.context) {
          this.context.removeVariable(ref);
        }
      }
    }
    (_this$registry = this.registry) === null || _this$registry === void 0 ? void 0 : _this$registry.change({
      type: "block",
      op: "update",
      key: this.key
    });
    this.block.specUpdated();
    this.type.renderType();
  }
}
exports.BlockInteractionManager = BlockInteractionManager;
//# sourceMappingURL=BlockInteractionManager.js.map